import * as Icons from '@lucide/svelte';
import type { IconType } from '../../components/icons/icons.types';

/** The icons of the intranet module. */
class IntranetIconsClass {
    public readonly Entry: IconType = Icons.TextInitial;
    public readonly EntryCreate: IconType = Icons.FilePlus;
    public readonly Intranet: IconType = Icons.SquareLibrary;
    public readonly IntranetCreate: IconType = Icons.Plus;
    public readonly Open: IconType = Icons.BookOpen;
    public readonly Php: IconType = Icons.Computer;
    public readonly Point: IconType = Icons.List;
    public readonly PointCreate: IconType = Icons.ListPlus;
    public readonly Up: IconType = Icons.ArrowLeft;
    public readonly View: IconType = Icons.Eye;
}

export const IntranetIcons = new IntranetIconsClass();
